import { Settings, Info } from "lucide-react";
import { cn } from "@/lib/utils";

interface EchoSettingsProps {
  onClose?: () => void;
}

export function EchoSettings({ onClose }: EchoSettingsProps) {
  return (
    <div className="w-96 bg-white rounded-lg border border-gray-200 shadow-lg overflow-hidden">
      {/* Header */}
      <div className="flex items-center justify-between gap-3 border-b px-5 py-4">
        <div className="flex items-center gap-2">
          <Settings className="h-4 w-4 text-gray-600" />
          <h2 className="text-sm font-semibold text-[#1a1a1a]">Echo Settings</h2>
        </div>
        {onClose && (
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            ✕
          </button>
        )}
      </div>

      {/* Content */}
      <div className="px-5 py-4 space-y-4">
        <div>
          <label className="block text-sm font-medium text-[#1a1a1a] mb-3">
            LLM Model Configuration
          </label>
          <div className="space-y-3">
            {/* Info Box */}
            <div className="flex gap-2 p-3 rounded-lg bg-blue-50 border border-blue-200">
              <Info className="h-4 w-4 text-blue-600 mt-0.5 flex-shrink-0" />
              <p className="text-xs text-blue-900">
                Model is configured via environment variable. To change it, edit <code className="text-[11px] bg-white px-1 rounded">ECHO_LLM_MODEL</code> in <code className="text-[11px] bg-white px-1 rounded">.env.local</code> and restart Echo.
              </p>
            </div>

            {/* Kimi Info */}
            <div className="p-3 rounded-lg border border-gray-200 bg-gray-50">
              <div className="font-medium text-[#1a1a1a] text-sm">Kimi K2.6</div>
              <div className="text-xs text-gray-600 mt-0.5">
                Reasoning-optimized. Fast. Default.
              </div>
            </div>

            {/* Llama Info */}
            <div className="p-3 rounded-lg border border-gray-200 bg-gray-50">
              <div className="font-medium text-[#1a1a1a] text-sm">Llama 3.3 70B</div>
              <div className="text-xs text-gray-600 mt-0.5">
                Conversational. Larger context. Set <code className="text-[11px] bg-white px-1 rounded">ECHO_LLM_MODEL=llama</code> to use.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function EchoSettingsToggle({ onClick }: { onClick: () => void }) {
  return (
    <button
      type="button"
      aria-label="Echo settings"
      onClick={onClick}
      className="relative flex h-9 w-9 items-center justify-center rounded-lg border bg-background text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
    >
      <Settings className="h-[18px] w-[18px]" />
    </button>
  );
}
